import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wil-landing-programme-example',
  standalone: true,
  templateUrl: './landing-programme-example.component.html',
  styleUrl: './landing-programme-example.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LandingProgrammeExampleComponent {
  public readonly delegationCategories = input.required<readonly string[]>();
  public readonly conversationCategories = input.required<readonly string[]>();
}
